export default "__VITE_ASSET__DSfqJkpW__"